import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEarthAsia,
  faUsers,
  faSeedling,
  faShippingFast,
} from "@fortawesome/free-solid-svg-icons";
import delivaryExcellance from "../images/excellence/delivaryExcellence.png";
import delivaryExcellancemobile from "../images/excellence/delivaryExcellencemobile.png";

const HomeourExcellence = () => {
  return (
    <>
      <section className="export-section">
        <div className="overlaye"></div>

        <div className="contente">
          <p className="tage">Delivering Excellence</p>

          <h1>
            Trusted Global <br /> Export Solutions
          </h1>

          <div className="gride">
            <div className="carde">
              <FontAwesomeIcon icon={faEarthAsia} />
              <h2>7+</h2>
              <p>Countries Exported</p>
            </div>

            <div className="carde">
              <FontAwesomeIcon icon={faUsers} />
              <h2>500+</h2>
              <p>Happy Clients</p>
            </div>

            <div className="carde">
              <FontAwesomeIcon icon={faSeedling} />
              <h2>70+</h2>
              <p>Tons of Fresh Produce</p>
            </div>

            <div className="carde">
              <FontAwesomeIcon icon={faShippingFast} />
              <h2>99%</h2>
              <p>On-Time Delivery</p>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        .export-section {
          position: relative;
          min-height: 420px;
          display: flex;
          align-items: center;
          padding: 40px 8%;
          background: url(${delivaryExcellance}) center/cover no-repeat;
          overflow: hidden;
        }

        /* MOBILE BACKGROUND SWITCH */
        @media (max-width: 768px) {
          .export-section {
            background: url(${delivaryExcellancemobile}) center/cover no-repeat;
          }
        }

        .overlaye {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(0, 80, 31, 0.65) 0%, rgba(0,0,0,0.4) 100%);
        }

        .contente {
          position: relative;
          z-index: 2;
          color: white;
          max-width: 1200px;
        }

        .tage {
          color: #f9d93d;
          font-size: 24px;
          font-weight: 700;
          margin-bottom: 10px;
        }

        .contente h1 {
          font-size: clamp(28px, 4vw, 42px);
          font-weight: 800;
          line-height: 1.2;
          margin-bottom: 30px;

          /* Gradient text */
          background: linear-gradient(90deg, #ffffff, #ffffff, #ffffff);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;

          /* Subtle glow */
          text-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);

          /* Smooth rendering */
          letter-spacing: 0.5px;
        }

        /* DESKTOP: FLEX */
        .gride {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
        }

        .carde {
          background: rgba(255, 255, 255, 0.21);
          backdrop-filter: blur(20px);
          padding: 20px;
          border-radius: 14px;
          width: 160px;
          text-align: center;
          border: 1px solid rgba(255,255,255,0.2);
          transition: 0.4s;
        }

        .carde svg {
          font-size: 34px;
          margin-bottom: 10px;
          color: #4ade80;
        }

        .carde h2 {
          font-size: 26px;
          color: gold;
          font-weight: 700;
          margin: 5px 0;
          background: gold;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        /* subtle black shadow */
        text-shadow: 0 2px 3px rgba(151, 148, 148, 0.4);
        }

        .carde p {
          font-size: 13px;
          font-weight: 600;
          color: #ffffff;
        }

        .carde:hover {
          transform: translateY(-8px) scale(1.05);
          background: rgba(255, 255, 255, 0.15);
          box-shadow: 0 10px 30px rgba(0,0,0,0.4);
        }

        /* ✅ MOBILE: 2 GRID LAYOUT */
        @media (max-width: 768px) {
          .contente h1 {
            font-size: 24px;
          }

          .gride {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 25px;
          }

          .carde {
            width: 100%;
            padding: 25px;
          }
        }
      `}</style>
    </>
  );
};

export default HomeourExcellence;
